import useSWRMutation from "swr/mutation";
import { postOnly } from "../../helpers/fetchHandleError";

export const useUserActionLogger = (option = {}) => {
  return useSWRMutation(
    `${process.env.REACT_APP_CLOUDFLARE_HOST}/api/user-actions`,
    postOnly,
    {
      ...option,
    }
  );
};
